module.exports = __webpack_public_path__ + "img/logo.80e6315b.png";